$(function(){
    let thisPageTitle = $('.shop_visual .shop_visual_box .shop_visual_t01').text();

    $('.collection_sub ul li').each(function(){
        const thisCollectionCate = $(this).find('a').attr('rel');
        if(thisCollectionCate == thisPageTitle){
            $(this).find('a').addClass('on')
        }
    })
})